import { default as Delegate } from "eventslibjs/src/js/events/events.js";

export class Events {

  /**
   *
   *
   * @static
   * @param {*} el
   * @param {*} eventsList
   * @param {*} fn
   * @param {boolean} [options=false]
   * @memberof Events
   */
  static on(el, eventsList, fn, options = false) {
    eventsList.split(' ').forEach(e => el.addEventListener(e, fn, options));
  }

  static get delegate() {
    return Delegate;
  }

}
